import { useMessageConversationErrorLogSubscription } from '@/types/generated/graphql';
import { notification } from 'antd';

export function useCallFailedErrorSusbcription() {
  useMessageConversationErrorLogSubscription({
    onData: (res) => {
      notification.destroy();
      notification.error({ message: res?.data?.data?.messageConversationErrorLog?.message });
    },
  });
}
